/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './gynaec-checklist.reducer';

export const GynaecChecklist = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const gynaecChecklistList = useAppSelector(state => state.gynaecChecklist.entities);
  const loading = useAppSelector(state => state.gynaecChecklist.loading);
  const totalItems = useAppSelector(state => state.gynaecChecklist.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="gynaec-checklist-heading" data-cy="GynaecChecklistHeading">
        <Translate contentKey="tinyMedicRestApp.gynaecChecklist.home.title">Gynaec Checklists</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.gynaecChecklist.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/gynaec-checklist/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.gynaecChecklist.home.createLabel">Create new Gynaec Checklist</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.gynaecChecklist.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {gynaecChecklistList && gynaecChecklistList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.gynaecChecklist.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('motherAntibiotics')}>
                  <Translate contentKey="tinyMedicRestApp.gynaecChecklist.motherAntibiotics">Mother Antibiotics</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('motherAntibiotics')} />
                </th>
                <th className="hand" onClick={sort('mChills')}>
                  <Translate contentKey="tinyMedicRestApp.gynaecChecklist.mChills">M Chills</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('mChills')} />
                </th>
                <th className="hand" onClick={sort('mFsvd')}>
                  <Translate contentKey="tinyMedicRestApp.gynaecChecklist.mFsvd">M Fsvd</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('mFsvd')} />
                </th>
                <th className="hand" onClick={sort('mLat')}>
                  <Translate contentKey="tinyMedicRestApp.gynaecChecklist.mLat">M Lat</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('mLat')} />
                </th>
                <th className="hand" onClick={sort('mLateRuptureOfMembranes')}>
                  <Translate contentKey="tinyMedicRestApp.gynaecChecklist.mLateRuptureOfMembranes">M Late Rupture Of Membranes</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('mLateRuptureOfMembranes')} />
                </th>
                <th className="hand" onClick={sort('mDelayedLabour')}>
                  <Translate contentKey="tinyMedicRestApp.gynaecChecklist.mDelayedLabour">M Delayed Labour</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('mDelayedLabour')} />
                </th>
                <th className="hand" onClick={sort('bAntibiotics')}>
                  <Translate contentKey="tinyMedicRestApp.gynaecChecklist.bAntibiotics">B Antibiotics</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('bAntibiotics')} />
                </th>
                <th className="hand" onClick={sort('bAbnormalBreathing')}>
                  <Translate contentKey="tinyMedicRestApp.gynaecChecklist.bAbnormalBreathing">B Abnormal Breathing</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('bAbnormalBreathing')} />
                </th>
                <th className="hand" onClick={sort('bChestGrunting')}>
                  <Translate contentKey="tinyMedicRestApp.gynaecChecklist.bChestGrunting">B Chest Grunting</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('bChestGrunting')} />
                </th>
                <th className="hand" onClick={sort('bConvulsions')}>
                  <Translate contentKey="tinyMedicRestApp.gynaecChecklist.bConvulsions">B Convulsions</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('bConvulsions')} />
                </th>
                <th className="hand" onClick={sort('bLooksSick')}>
                  <Translate contentKey="tinyMedicRestApp.gynaecChecklist.bLooksSick">B Looks Sick</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('bLooksSick')} />
                </th>
                <th className="hand" onClick={sort('bTooCold')}>
                  <Translate contentKey="tinyMedicRestApp.gynaecChecklist.bTooCold">B Too Cold</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('bTooCold')} />
                </th>
                <th className="hand" onClick={sort('bTooHot')}>
                  <Translate contentKey="tinyMedicRestApp.gynaecChecklist.bTooHot">B Too Hot</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('bTooHot')} />
                </th>
                <th className="hand" onClick={sort('bStoppedFeeding')}>
                  <Translate contentKey="tinyMedicRestApp.gynaecChecklist.bStoppedFeeding">B Stopped Feeding</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('bStoppedFeeding')} />
                </th>
                <th className="hand" onClick={sort('bExcessiveCrying')}>
                  <Translate contentKey="tinyMedicRestApp.gynaecChecklist.bExcessiveCrying">B Excessive Crying</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('bExcessiveCrying')} />
                </th>
                <th className="hand" onClick={sort('bUmblicalRedness')}>
                  <Translate contentKey="tinyMedicRestApp.gynaecChecklist.bUmblicalRedness">B Umblical Redness</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('bUmblicalRedness')} />
                </th>
                <th className="hand" onClick={sort('mBleedingControlled')}>
                  <Translate contentKey="tinyMedicRestApp.gynaecChecklist.mBleedingControlled">M Bleeding Controlled</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('mBleedingControlled')} />
                </th>
                <th className="hand" onClick={sort('bFeedingNormal')}>
                  <Translate contentKey="tinyMedicRestApp.gynaecChecklist.bFeedingNormal">B Feeding Normal</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('bFeedingNormal')} />
                </th>
                <th className="hand" onClick={sort('bNotes')}>
                  <Translate contentKey="tinyMedicRestApp.gynaecChecklist.bNotes">B Notes</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('bNotes')} />
                </th>
                <th className="hand" onClick={sort('mNotes')}>
                  <Translate contentKey="tinyMedicRestApp.gynaecChecklist.mNotes">M Notes</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('mNotes')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.gynaecChecklist.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.gynaecChecklist.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('lastupdated')}>
                  <Translate contentKey="tinyMedicRestApp.gynaecChecklist.lastupdated">Lastupdated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastupdated')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.gynaecChecklist.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampentry')}>
                  <Translate contentKey="tinyMedicRestApp.gynaecChecklist.timestampentry">Timestampentry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampentry')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.gynaecChecklist.patient">Patient</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.gynaecChecklist.incident">Incident</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {gynaecChecklistList.map((gynaecChecklist, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/gynaec-checklist/${gynaecChecklist.id}`} color="link" size="sm">
                      {gynaecChecklist.id}
                    </Button>
                  </td>
                  <td>{gynaecChecklist.motherAntibiotics ? 'true' : 'false'}</td>
                  <td>{gynaecChecklist.mChills ? 'true' : 'false'}</td>
                  <td>{gynaecChecklist.mFsvd ? 'true' : 'false'}</td>
                  <td>{gynaecChecklist.mLat ? 'true' : 'false'}</td>
                  <td>{gynaecChecklist.mLateRuptureOfMembranes ? 'true' : 'false'}</td>
                  <td>{gynaecChecklist.mDelayedLabour ? 'true' : 'false'}</td>
                  <td>{gynaecChecklist.bAntibiotics ? 'true' : 'false'}</td>
                  <td>{gynaecChecklist.bAbnormalBreathing ? 'true' : 'false'}</td>
                  <td>{gynaecChecklist.bChestGrunting ? 'true' : 'false'}</td>
                  <td>{gynaecChecklist.bConvulsions ? 'true' : 'false'}</td>
                  <td>{gynaecChecklist.bLooksSick ? 'true' : 'false'}</td>
                  <td>{gynaecChecklist.bTooCold ? 'true' : 'false'}</td>
                  <td>{gynaecChecklist.bTooHot ? 'true' : 'false'}</td>
                  <td>{gynaecChecklist.bStoppedFeeding ? 'true' : 'false'}</td>
                  <td>{gynaecChecklist.bExcessiveCrying ? 'true' : 'false'}</td>
                  <td>{gynaecChecklist.bUmblicalRedness ? 'true' : 'false'}</td>
                  <td>{gynaecChecklist.mBleedingControlled ? 'true' : 'false'}</td>
                  <td>{gynaecChecklist.bFeedingNormal ? 'true' : 'false'}</td>
                  <td>{gynaecChecklist.bNotes}</td>
                  <td>{gynaecChecklist.mNotes}</td>
                  <td>{gynaecChecklist.active ? 'true' : 'false'}</td>
                  <td>{gynaecChecklist.cursor}</td>
                  <td>{gynaecChecklist.lastupdated}</td>
                  <td>{gynaecChecklist.microSec}</td>
                  <td>{gynaecChecklist.timestampentry}</td>
                  <td>
                    {gynaecChecklist.patient ? (
                      <Link to={`/gluco-user/${gynaecChecklist.patient.id}`}>{gynaecChecklist.patient.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {gynaecChecklist.incident ? (
                      <Link to={`/labor-incident/${gynaecChecklist.incident.id}`}>{gynaecChecklist.incident.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/gynaec-checklist/${gynaecChecklist.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/gynaec-checklist/${gynaecChecklist.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/gynaec-checklist/${gynaecChecklist.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.gynaecChecklist.home.notFound">No Gynaec Checklists found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={gynaecChecklistList && gynaecChecklistList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default GynaecChecklist;
